export interface Transactions {
    id: number;
    corporateId: number;
    businessName: string;
    transactionReference: string;
    transactionType: number;
    transactionAction: string;
    amountFrom: number;
    amountTo: number;
    fromCurrencyCode: string;
    toCurrencyCode: string;
    fromWalletId: number;
    toWalletId: number;
    narration: string;
    rateValue: number;
    transactionStartDate: string;
    createdDate: string;
    status: number;
    transactionEndDate?: string;
    corporateBeneficiaryName?: string;
    audit?: TransactionAudit[];
    documents: TransactionDocument[];
    extra: TransactionExtra[];
}

export interface GetTransactionsParams {
    page: number;
    size: number;
    amountRangeStart?: number;
    amountRangeEnd?: number;
    corporateBeneficiaryId?: string;
    status?: string | number;
    createdDateFrom?: string;
    createdDateTo?: string;
}

export interface TransactionAudit {
    createdBy: string;
    createdDate: string;
    lastModifiedBy: string;
    lastModifiedDate: string;
    version: number;
    status: number;
    authorized: number;
    id: number;
    corporateTransactionReference: string;
    corporateId: number;
    action: string;
    visible: number;
}

export interface TransactionDocument {
    createdBy: string;
    createdDate: string;
    lastModifiedBy: string;
    lastModifiedDate: string;
    version: number;
    status: number;
    authorized: number;
    id: number;
    corporateTransactionReference: string;
    corporateId: number;
    documentUrl: string;
}

export interface TransactionExtra {
    createdBy: string;
    createdDate: string;
    lastModifiedBy: string;
    lastModifiedDate: string;
    version: number;
    status: number;
    authorized: number;
    id: number;
    corporateTransactionReference: string;
    corporateId: number;
    key: string;
    value: string;
}

export enum TransactionStatus {
    CANCELED,
    COMPLETED = 1,
    PROCESSING_BENEFICIARY = 5,
    PROCESSING_OUT,
    PROCESSING_IN,
    PROCESSING,
    INITIATED,
    PENDING = 10,
    REJECTED
}
